import { ClearAllButton } from '@terminal/views/scenario/header/clear-all-button/ClearAllButton';
import { useTranslation } from 'react-i18next';

import sharedStyles from '../Shared.module.scss';
import styles from './ScenarioNoFilteredAssets.module.scss';

interface ScenarioNoFilteredAssetsProps {
  onAbort: () => void;
  onClearScenarioTable: () => void;
}

export const ScenarioNoFilteredAssets = ({
  onAbort,
  onClearScenarioTable,
}: ScenarioNoFilteredAssetsProps) => {
  const { t } = useTranslation('screener');

  return (
    <div className={sharedStyles.container} data-testid="scenario-no-assets">
      <img
        className={sharedStyles.img}
        src="/app/static/images/icons/no-assets-found.svg"
        alt=""
      />
      <div className={styles.description}>
        <p className={sharedStyles.title}>{t('screener:emptyTitle')}</p>
        <p className={sharedStyles.message}>{t('screener:emptyMessage')}</p>
      </div>
      <ClearAllButton
        onAbort={onAbort}
        onClearScenarioTable={onClearScenarioTable}
      />
    </div>
  );
};
